import React, { useState, useRef, useEffect } from "react";
import $ from "jquery";

import GBTSLogoSvg from "../../assets/GBTSLogoSvg";

import BuddibleSocket from "../../lib/BuddibleSocket";
import Utilities from "../../lib/Utilities";
import CodeList from "../../lib/CodeList";
import { useTranslation } from "react-i18next";

window.jQuery = $;
window.$ = $;
global.jQuery = $;
const socket = new BuddibleSocket();
const util = new Utilities();
const codeList = new CodeList();

export default function FindPW() {
  const { t, i18n } = useTranslation();
  const [idChk, setIdChk] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const $controllers = {
    COMP_CD: useRef(),
    USER_ID: useRef(),
  };

  useEffect(() => {
    i18n.changeLanguage(i18n.language);
  }, []);

  function checkEmail(str) {
    let reg_email =
      /^([0-9a-zA-Z_\.-]+)@([0-9a-zA-Z_-]+)(\.[0-9a-zA-Z_-]+){1,2}$/;
    return reg_email.test(str);
  }

  function checkValidation() {
    if ($controllers.COMP_CD.current.value.trim() === "") {
      codeList.Modal.current.alert(t("commonMSG.enterCompanyCode"), () => {
        $controllers.COMP_CD.current.focus();
      });
      return false;
    }

    if ($controllers.USER_ID.current.value.trim() === "") {
      codeList.Modal.current.alert(t("find.msg.enterEmail"), () => {
        $controllers.USER_ID.current.focus();
      });
      return false;
    }

    if (!idChk) {
      codeList.Modal.current.alert(t("commonMSG.invalidEmail"), () => {
        $controllers.USER_ID.current.focus();
      });
      return false;
    }

    return true;
  }

  function requestUserUpdate() {
    if (checkValidation() === false) return;

    const msgID = util.makeUUIDv4();
    const socketMsg = {
      file: "/join/JS_join_gbts_comp_user_find_pw.php",
      msgID: msgID,
      data: {},
      COMP_CD: util.buddibleEncrypt($controllers.COMP_CD.current.value),
      USER_ID: util.buddibleEncrypt($controllers.USER_ID.current.value),
    };

    setIsLoading(true);
    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData) {
        if (newData["ret"]) {
          codeList.Modal.current.alert(t("find.msg.success"), () => {
            if (window.location.hash === "#logiwork") {
              window.location.replace("https://system.gbts.co.kr/login.do");
            }
          });
        } else {
          codeList.Modal.current.alert(newData["MSG"] || t("commonMSG.error"));
        }

        setIsLoading(false);
      }
    });
  }

  return (
    <div className="vh-100 d-flex flex-column align-items-center justify-content-center bg-light">
      <GBTSLogoSvg height={60} />
      <p className="mt-2 mb-3 h5 font-weight-bold text-secondary">
        {t("find.pw.title")}
      </p>
      <div className="bg-white p-2 rounded shadow-sm" style={{ minWidth: 700 }}>
        <div className="container-fluid">
          <div className="py-3 d-block">
            <div className="mb-3 row">
              <label className="col-form-label col-sm-3 text-end">
                {t("find.pw.compCode")}
              </label>
              <div className="col-sm-9">
                <input
                  type="text"
                  disabled={isLoading}
                  className="form-control"
                  ref={$controllers.COMP_CD}
                />
              </div>
            </div>

            <div className="row mb-3">
              <label className="col-form-label col-sm-3 text-end">
                {t("find.pw.email")}
              </label>
              <div className="col d-flex flex-row">
                <input
                  className="form-control"
                  type="email"
                  disabled={isLoading}
                  ref={$controllers.USER_ID}
                  onChange={(e) => {
                    setIdChk(checkEmail(e.target.value));
                  }}
                />
              </div>
            </div>

            {!idChk ? (
              <div className="mb-3 row" style={{ marginTop: -10 }}>
                <label className="col-form-label col-sm-3 text-end"></label>
                <div className="col-sm-9" style={{ textAlign: "left" }}>
                  <span style={{ color: "#f64a4a" }}>
                    {t("commonMSG.invalidEmail")}
                  </span>
                </div>
              </div>
            ) : (
              <></>
            )}
            <p className="text-danger">{t("find.pw.notice")}</p>
          </div>
          <div className="text-right mb-2">
            <button
              type="button"
              className="btn_1"
              disabled={isLoading}
              onClick={() => {
                requestUserUpdate();
              }}
            >
              {t("find.pw.submit")}
              {isLoading && (
                <span
                  className="spinner-border spinner-border-sm ml-2"
                  role="status"
                  aria-hidden="true"
                />
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
